<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['username', validatorRules.username]"
            placeholder="请输入账号"
            :disabled="disabled"
            @blur="getRandomPassword()"
          ></a-input>
        </a-form-item>
        <a-form-item label="密码" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input v-decorator="['password', validatorRules.password]" readOnly></a-input>
        </a-form-item>
        <a-form-item label="秘钥" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['clearPassword', validatorRules.clearPassword]"
            placeholder="输入账号将自动生成秘钥"
            readOnly
          ></a-input>
        </a-form-item>
        <a-form-item label="来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['sources', validatorRules.sources]" placeholder="请输入来源"></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['remark', validatorRules.remark]" placeholder="请输入备注"></a-input>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="radio"
            v-decorator="['status', validatorRules.status]"
            :trigger-change="true"
            dictCode="on_off"
            placeholder="请选择状态"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { getAction, httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import { createPassword } from '@/api/api'

export default {
  name: 'BusCommonMessageTokenUserModal',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      disabled: true,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        username: {
          rules: [
            { required: true, message: '请输入账号!' },
            {
              validator: (rule, value, callback) => {
                this.checkUsername(value, this.model.id, callback)
              },
            },
          ],
        },
        password: { rules: [] },
        sources: { rules: [] },
        remark: { rules: [] },
        status: { rules: [{ required: true, message: '请选择状态!' }] },
        clearPassword: { rules: [] },
      },
      url: {
        add: '/base/busCommonMessageTokenUser/add',
        edit: '/base/busCommonMessageTokenUser/edit',
      },
    }
  },
  created() {},
  methods: {
    getRandomPassword() {
      if (
        (this.form.getFieldValue('clearPassword') == null &&
          this.form.getFieldValue('username') != '' &&
          this.form.getFieldValue('username') != null) ||
        (this.form.getFieldValue('clearPassword') == '' &&
          this.form.getFieldValue('username') != '' &&
          this.form.getFieldValue('username') != null)
      ) {
        createPassword().then((res) => {
          if (res.success) {
            this.form.setFieldsValue({
              clearPassword: res.message,
            })
            this.form.setFieldsValue({
              password: res.message,
            })
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    add() {
      // this.edit({"status":"1"});
      this.disabled = false
      this.form.resetFields()
      this.model = Object.assign({}, { status: '1' })
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'username', 'password', 'clearPassword', 'sources', 'remark', 'status')
        )
      })
    },
    edit(record) {
      this.disabled = true
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'username', 'password', 'clearPassword', 'sources', 'remark', 'status')
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'username', 'password', 'sources', 'remark', 'status'))
    },
    //验证账户是否唯一
    checkUsername(username, id, callback) {
      if (username != null && username != '') {
        let params = { username, id }
        getAction('/base/busCommonMessageTokenUser/checkUsername', params)
          .then((res) => {
            res['success'] ? callback() : callback(res['message'])
          })
          .catch((err) => {
            callback(err.message || err)
          })
      } else {
        callback()
      }
    },
  },
}
</script>
